import { render, staticRenderFns } from "./BreakDetails.vue?vue&type=template&id=7e4a96c5&"
import script from "./BreakDetails.vue?vue&type=script&setup=true&lang=ts&"
export * from "./BreakDetails.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports